<!-- Public, login-free routes (e.g. the share-link issue form) render standalone:
     no navbar/sidenav/loading gate/AI chat, since all of those depend on an
     authenticated session. The page supplies its own minimal layout. -->
@if (onPublicRoute()) {
  <router-outlet></router-outlet>
} @else {
<div>
  @if (isAuthLoading() || moduleStoreLoading() ||
  loadContextOverride()){
  <div class="full-height" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; background: white;">
    <gcp-workspace-loading></gcp-workspace-loading>
  </div>
  }

  <!-- Always render the app content to prevent component destruction/state loss -->
  <div>
    <mat-sidenav-container>
      <mat-sidenav
        mode="side"
        [opened]="isAuthenticated()"
        [class.sidenav-collapsed]="sidenavUi.collapsed()"
      >
        <gcp-workspace-sidenav></gcp-workspace-sidenav>
      </mat-sidenav>

      <mat-sidenav-content>
        <gcp-workspace-navbar></gcp-workspace-navbar>
        <div class="main-content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <gcp-workspace-error-notification></gcp-workspace-error-notification>

    @if (isAuthenticated() && !isAiRoute() && hasAiAccess() && aiChatUi.isOpen()) {
      <gcp-workspace-ai-chat-window></gcp-workspace-ai-chat-window>
    }

    @if (isAuthenticated() && showFloatingChatLauncher()) {
      <button
        class="floating-ai-launcher"
        type="button"
        [class.active]="aiChatUi.isOpen()"
        (click)="toggleFloatingChat()"
        [matTooltip]="floatingChatHint()"
        matTooltipPosition="left"
        [attr.aria-label]="floatingChatHint()"
      >
        @if (aiChatUi.isOpen()) {
          <mat-icon class="material-symbols-rounded">expand_circle_down</mat-icon>
        } @else {
          <gcp-workspace-gurc-mark [size]="30" />
        }
      </button>
    }
  </div>
</div>
}
